
export interface ShoppingCartState {
    loading: boolean;
    error: boolean;
    errorMessage: string;
    suggested: ShoppingCartSuggested;
}

/** Error de inputs por producto (precio y cantidad por separado; elite_zone solo aplica a Elite). */
export interface ProductInputErrors {
    price: boolean;
    quantity: boolean;
    elite_zone?: boolean;
}

/** Estado de selección del carrito comercial (qué eligió el usuario de lo sugerido). */
export interface CommercialCartSelection {
    selectedByProductId: Record<number, boolean>;
    quantityByProductId: Record<number, number>;
    priceByProductId: Record<number, number>;
    /** Errores de validación de inputs por producto. */
    inputErrorByProductId: Record<number, ProductInputErrors>;
    /** Zona geográfica seleccionada por producto (solo aplica a Elite). */
    eliteZoneByProductId: Record<number, string>;
    /** Meses seleccionados (1-12). null = ninguno seleccionado. */
    selectedMonths: number | null;
    /** Método de pago (valor enviado como Payment-Method al endpoint). null = ninguno seleccionado. */
    selectedPaymentMethod: number | null;
    /** Indica si el usuario activó MSI (Meses Sin Intereses). Solo aplica para Tarjeta. */
    msiEnabled: boolean;
    /** Meses MSI seleccionados (3, 6, 9 o 12). null = ninguno seleccionado. */
    msiMonths: number | null;
}

export const initialCommercialCartSelection: CommercialCartSelection = {
    selectedByProductId: {},
    quantityByProductId: {},
    priceByProductId: {},
    inputErrorByProductId: {},
    eliteZoneByProductId: {},
    selectedMonths: null,
    selectedPaymentMethod: null,
    msiEnabled: false,
    msiMonths: null,
};

/** Ítem dentro de `active_products_by_expiration_month` (suggested_calculator). */
export interface ActiveProductByExpirationItem {
    period_id: number;
    product_id: number | null;
    name_product: string | null;
    category: string;
    subcategory: string | null;
    type_package: string | null;
    type_plan: string | null;
    start_date: string;
    end_date: string;
    package_slot_category_id: number | null;
}

/** Claves `YYYY-MM` → productos que expiran en ese mes. */
export type ActiveProductsByExpirationMonth = Record<string, ActiveProductByExpirationItem[]>;

export interface ShoppingCartSuggested {
    products: Products;
    users: User;
    user_profile: UserProfile;
    success: boolean;
    /** Agrupación por año-mes del API (`active_products_by_expiration_month`). */
    active_products_by_expiration_month: ActiveProductsByExpirationMonth;
    /** Selección del usuario en el carrito comercial (no viene del API). */
    selection: CommercialCartSelection;
}

export interface Discount {
    discount: number;
    volumen: number;
}
export interface Products {
    category: CategoryProducts;
}
export interface ProductByCategory {
    product_id: number;
    name_product: string;
    price: number;
    discount: number | null;
    description: string;
    category: string;
    subcategory: string;
}

export interface CategoryProducts {
    Destacado: ProductByCategory[];
    elite: ProductByCategory[];
    Leads: ProductByCategory[];
    smart_leads: ProductByCategory[];
    premium: ProductByCategory[];
}


export interface PropertiesForCategory {
    alta?: number;
    media?: number;
    baja?: number;
}
export interface PropertiesForCategoryHighlighted {

    alta?: number;
    media?: number;
    baja?: number;
}
export interface User {
    email: string;
    user_id: number;
}

export interface FreemiumStateLeads {
    used: number;
    limit: number;
}

export interface FreemiumStatePeriod {
    days_left_premium: number | null;
    days_until_penalty_ends: number | null;
}

/** Ítems de `users_delivery_leads_periods_cart_product_9` (suggested_calculator). */
export interface FreemiumStateDeliveryLeadCartProduct9 {
    cart_product_id: number;
    is_active: number;
}

export interface FreemiumState {
    plan: "freemium" | "premium";
    is_blocked: boolean;
    leads: FreemiumStateLeads;
    period: FreemiumStatePeriod;
    users_delivery_leads_periods_cart_product_9?: FreemiumStateDeliveryLeadCartProduct9[];
}

export interface ContactPhone {
    phone: string | null;
    country_code: string | null;
}

export interface UserProfile {
    name: string;
    lastname: string;
    user_created_at: string;
    broker_type: string;
    active_properties: number;
    highlighted_properties: number;
    total_active_slots: number;
    freemium_state: FreemiumState | null;
    phone_whatsapp: string | null;
    phone_contact: string | null;
    feed_name: string;
    from_xml: number;
    /** El API de suggested_calculator puede anidar aquí el mapa por mes. */
    active_products_by_expiration_month?: ActiveProductsByExpirationMonth;
    users_delivery_leads_periods_cart_product_9?: FreemiumStateDeliveryLeadCartProduct9[];
}

export const initialShoppingCart: ShoppingCartState = {
    loading: false,
    error: false,
    errorMessage: '',
    suggested: {
        products: {
            category: {
                Destacado: [],
                elite: [],
                Leads: [],
                smart_leads: [],
                premium: []
            }
        },
        users: {
            email: "",
            user_id: 0
        },
        active_products_by_expiration_month: {},
        user_profile: {
            name: '',
            lastname: '',
            user_created_at: '',
            broker_type: '',
            active_properties: 0,
            highlighted_properties: 0,
            total_active_slots: 0,
            freemium_state: null,
            phone_whatsapp: null,
            phone_contact: null,
            feed_name: '',
            from_xml: 0,
        },
        success: false,
        selection: initialCommercialCartSelection
    }
};
